import type { LatLng } from '@/shared/types';
import deepLinkGenerators, {
	type Device,
	type NavigationApp,
} from './deepLink';

type TUseNavigationDeepLinkParams = {
	stationLocation: LatLng | null;
	userLocation: LatLng | null;
	stationName?: string;
};

const device: Device = /iPhone|iPad|iPod|Macintosh/i.test(navigator.userAgent)
	? 'ios'
	: 'android';

const useNavigationDeepLink = ({
	stationLocation,
	userLocation,
	stationName,
}: TUseNavigationDeepLinkParams) => {
	const launchNavigationApp = (app: NavigationApp): void => {
		if (!stationLocation) return;
		window.location.href = deepLinkGenerators[device][app](
			userLocation?.lat ?? 0,
			userLocation?.lng ?? 0,
			stationLocation.lat,
			stationLocation.lng,
			stationName,
		);
	};

	return { launchNavigationApp };
};

export default useNavigationDeepLink;
